export default __webpack_public_path__ + "static/media/Consultoria-sistemas-gestao.6d329377.png";